import toast from '@/toast';
import { JsonErroHandlerFallback, JsonErrorHandlerDelegate } from './json-error-handler';

export class ToastFallback implements JsonErroHandlerFallback {
    constructor(private fallbackMessage?: string) {}

    onError(error: Error) {
        return showToast(this.fallbackMessage || error.message);
    }
}

export class ToastErrorHandler implements JsonErrorHandlerDelegate { 
    onJsonError(error: object) {
        if ('message' in error) {
            return showToast(error.message as string);
        }
    }
}

function showToast(message: string) {
    toast.error(message);
    return message;
}